<template>
  <div class="container">
    <!--UPLOAD-->
      <span class="title">1. Upload images, enter text, or choose from the gallery</span>
      <span class="sides" v-if="styleNumObj.sides== 2">
        <div :class="{active: currSide == 1}">
          <!-- Left -->
          <img v-if="styleNumObj.styleNum != 'jm0068'" :src="'https://app.brighton.com/lockets/img/'+styleNumObj.styleNum+'_mask2.png'" alt="">
          <img v-else :src="'https://app.brighton.com/lockets/img/'+styleNumObj.styleNum+'_mask2_1.png'" alt="">
        </div>
        <div :class="{active: currSide == 0}">
          <!-- Right -->
          <img :src="'https://app.brighton.com/lockets/img/'+styleNumObj.styleNum+'_mask2.png'" alt="">
        </div>
      </span>
      <span class="userInputType">
        <div :class="{active: data[currSide].userInputType == 1}" @click="selectUserInputType(1)" class="image">Image
        </div>
        <div :class="{active: data[currSide].userInputType == 2}" @click="selectUserInputType(2)" class="text">Text
        </div>
        <div :class="{active: data[currSide].userInputType == 3}" @click="selectUserInputType(3)" class="gallery">Gallery
        </div>
      </span>
      <form enctype="multipart/form-data" novalidate v-if="data[currSide].userInputType == 1" class="image">
        <span class="t1">Add a photo for image in the locket (or accessory) from your computer or mobile device. For best results, select a image with a resolution of 2100x1350 pixels or more. Supports JPEG / PNG / GIF / BMP image format.</span>
        <div class="nextStepBtn" v-if="readyForNextStep" >
            <button @click="nextStep($event)" v-if="data[currSide].userInputType == 1">Size Image <i class="fa fa-crop" aria-hidden="true"></i></button>
        </div>
        <div class="side side0">
          <div class="dropbox" v-if="data[currSide].userImage == null">
            <input type="file" ref="myBtn" name="uploadFieldName1" :disabled="data[currSide].isSaving" @change="filesChange($event.target.name, $event.target.files, 1); fileCount = $event.target.files.length" accept="image/*" class="input-file">
              <p v-if="!data[currSide].isSaving">
                <i class="fa fa-file-image-o" aria-hidden="true"></i>
                Click here to find your file
              </p>
              <p v-if="data[currSide].isSaving">
                Uploading file...<br/>
                <!-- Uploading {{ fileCount }} files...<br/> -->
                {{data[currSide].uploaded}}%
              </p>
              <span class="error" v-if="data[currSide].userImageErr!=null">
                {{data[currSide].userImageErr}}
              </span>
          </div>
          <div class="uploadedImage dropbox" v-if="data[currSide].userImage != null">
            <i class="fa fa-times" aria-hidden="true" @click="removeUserImage()"></i>
            <img :src="'https://app.brighton.com/lockets/tmp/'+data[currSide].userImage" alt="User Image 1" v-on:load="imageLoaded()"/>
          </div>
        </div>
      </form>
      

    <div v-if="data[currSide].userInputType == 2" class="userInputText text">
      <span class="t1">Personalize your locket or accessory with a message. </span>
      <div class="selectFont" id=""><label for="">Font: </label>
        <div class="selectedFont" @click="toggleAvailableFontsDropDownOpen">
          <span class="arrow"></span>
          <span class="font"  :style="availableFont.css" v-for="(availableFont, index) in availableFonts" :key="index" v-if="availableFont.selected">
            {{availableFont.name}}
          </span>
          <div class="fonts" :class="{expand: availableFontsDropDownOpen}">
            <span class="font" :style="availableFont.css" @click="selectFont(index)" v-for="(availableFont, index) in availableFonts" :key="index">
                {{availableFont.name}}
            </span>
          </div>
        </div>
      </div>
      <div class="customText">
        <div><label for="">Line1: </label><input :style="data[currSide].selectedFont" type="text" v-model="data[currSide].userInputText1" placeholder="Enter your message here" /> <span>{{userInputText1CharacterLeft}} character(s) left</span></div>
        <div><label for="">Line2: </label><input :style="data[currSide].selectedFont" type="text" v-model="data[currSide].userInputText2" placeholder="Enter your message here" /> <span>{{userInputText2CharacterLeft}} character(s) left</span></div>
        <div><label for="">Line3: </label><input :style="data[currSide].selectedFont" type="text" v-model="data[currSide].userInputText3" placeholder="Enter your message here" /> <span>{{userInputText3CharacterLeft}} character(s) left</span></div>
      </div>
    </div>
    <div v-if="data[currSide].userInputType == 3" class="gallery">
      <span class="t1">Select Image From Our Library </span>
      <div class="images">
        <div  class="image" v-for="(image, index) in gallery" @click="selectFromGallery(index)" :key="index">
          <img :src="'https://app.brighton.com/lockets/img/gallery/'+image.image" alt="">
        </div>
      </div>
    </div>
    <div class="control">
        <div class="error" v-if="errorMsg != null">{{errorMsg}}</div>
        <div class="nextStepBtn" v-if="readyForNextStep" >
            <button @click="nextStep()" v-if="data[currSide].userInputType == 1">Size Image <i class="fa fa-crop" aria-hidden="true"></i></button>
            <button @click="nextStep()" v-if="data[currSide].userInputType == 2">Save <i class="fa fa-eye" aria-hidden="true"></i></button>

        </div>
        <button @click="removeUserImage()" v-if="data[currSide].userImage != null">Choose another image</button>
        <button @click="startOver()">Start Over</button>
    </div>
  </div>
  


</template>

<script>
export default {
  name: 'Step1',
  props: {
    // sides: null,
    // reloadObj: Array,
    currSideG: Number,
    styleNumObj: null,
    // userImages: null,
    // selectedUserInputType: Number,
    // userInputTexts: Array,
    userData: Array,
    winowClicked: Number
  },
  data () {
    return {
      myBtn: null,
      counter: 0,
      uploadFieldName: 'abc',
      errorMsg: null,
      availableFonts: null,
      availableFontsDropDownOpen: false,
      currSide: 1,
      data: [
        {
          userImage: null,
          userImageErr: null,
          userInputType: 1,
          userInputText1: '',
          userInputText2: '',
          userInputText3: '',
          selectedFont: '',
          isSaving: false,
          uploaded: 0
        },
         {
          userImage: null,
          userImageErr: null,
          userInputType: 1,
          userInputText1: '',
          userInputText2: '',
          userInputText3: '',
          selectedFont: '',
          isSaving: false,
          uploaded: 0
        },
         {
          userImage: null,
          userImageErr: null,
          userInputType: 1,
          userInputText1: '',
          userInputText2: '',
          userInputText3: '',
          selectedFont: '',
          isSaving: false,
          uploaded: 0
        },
         {
          userImage: null,
          userImageErr: null,
          userInputType: 1,
          userInputText1: '',
          userInputText2: '',
          userInputText3: '',
          selectedFont: '',
          isSaving: false,
          uploaded: 0
        }
      ],
      gallery: [
      {'image': 'sample1.jpg'},
      {'image': 'sample2.jpg'},
      {'image': 'sample3.jpg'},
      {'image': 'sample4.jpg'},
      ]
    }
  },
  mounted (){
    var that = this
    console.log('mounted step 1')
    this.myBtn = this.$refs.myBtn
    this.currSide = this.currSideG
    if(this.userData != null)
      this.data = JSON.parse(JSON.stringify(this.userData))
    // set user selected image
    this.getAvailableFonts(function () {
      that.data[0].selectedFont = that.availableFonts[0].css
      that.data[1].selectedFont = that.availableFonts[0].css
      that.data[2].selectedFont = that.availableFonts[0].css
      that.data[3].selectedFont = that.availableFonts[0].css
    })
  
    this.getGalleryImages()

   that.$emit('setUserData', that.data, false)
        // console.log('emit etUserData3')
    that.$forceUpdate()
    document.body.scrollTop = 450 // For Safari
    document.documentElement.scrollTop = 450 // For Chrome, Firefox, IE and Opera
  },
  watch: {
    currSideG(newVal) {
      this.currSide = newVal
    },
    winowClicked(newValue) {
      console.log(newValue)
      this.availableFontsDropDownOpen = false
    },
    currSide(newValue) {
      console.log(newValue)
    }
  },
  computed: {
    // directionText() {
    //   if(this.data != null) {
    //     console.log('direction text')
    //   } else {
    //     console.log('userdata not available')
    //   }
    // },
    userInputText1CharacterLeft() {
      if(this.data[this.currSide].userInputText1.length > this.styleNumObj.line1CharacterLimit) 
        this.data[this.currSide].userInputText1 = this.data[this.currSide].userInputText1.slice(0, this.styleNumObj.line1CharacterLimit)
      return this.styleNumObj.line1CharacterLimit - (this.data[this.currSide].userInputText1.length);
      // return this.styleNumObj.line1CharacterLimit - (this.userInputText1.length);
    },
    userInputText2CharacterLeft() {
      if(this.data[this.currSide].userInputText2.length > this.styleNumObj.line2CharacterLimit) 
        this.data[this.currSide].userInputText2 = this.data[this.currSide].userInputText2.slice(0, this.styleNumObj.line2CharacterLimit)
      return this.styleNumObj.line2CharacterLimit - (this.data[this.currSide].userInputText2.length);
    },
    userInputText3CharacterLeft() {
      if(this.data[this.currSide].userInputText3.length > this.styleNumObj.line3CharacterLimit) 
        this.data[this.currSide].userInputText3 = this.data[this.currSide].userInputText3.slice(0, this.styleNumObj.line3CharacterLimit)
      return this.styleNumObj.line3CharacterLimit - (this.data[this.currSide].userInputText3.length);
    },
    
    readyForNextStep() {
      if(this.data[this.currSide].userInputType == 1 && (this.data[this.currSide].userImage == null || this.data[this.currSide].isSaving)) {
        return false
      }
      if(this.data[this.currSide].userInputType == 3 && (this.data[this.currSide].userImage == null || this.data[this.currSide].isSaving)) {
        return false
      }
      return true
    }
  },
  methods: {
    selectUserInputType(type) {
      this.data[this.currSide].userInputType = type
      if(type == 1 && this.data[this.currSide].userImage == null) {
        this.$forceUpdate()
      }
      this.setDefaultPreviewUserImage()
    },
    setDefaultPreviewUserImage(){
      let that = this
      if(that.currSide == 0){
        that.$emit('setPreviewUserImg', 
        {
          url1: 'https://app.brighton.com/lockets/img/'+that.styleNumObj.styleNum+'_preview0.png?3',
          url1Top: 'https://app.brighton.com/lockets/img/'+that.styleNumObj.styleNum+'_top.png?3',
          url2: ''
        });
      } else {
        that.$emit('setPreviewUserImg', 
        {
          url2: 'https://app.brighton.com/lockets/img/'+that.styleNumObj.styleNum+'_preview1.png?3',
          url1Top:'',
          url1: ''
        });
      }
    },
    selectFromGallery(index) {
      var that = this
      // _.forEach(this.gallery, function (image){
      //   image.selected = false
      // });
      this.gallery.map(image=>{
        image.selected = false
      })
      this.gallery[index].selected = true
      console.log(this.gallery[index].image)
      this.data[this.currSide].userImage = this.gallery[index].image
      this.duplicateGalleryImage (that.gallery[index].image, function (err, newFileName1) {
        if(err) {
          console.log(err)
        } else {
          that.data[that.currSide].userImage = newFileName1
          that.data[that.currSide].fromGallery = 1
          that.data[that.currSide].userInputType = 1
          // set preview
          console.log('set preview by picking pic from gallery')
          // that.setDefaultPreviewUserImage()
          that.$forceUpdate()
        }
      })
      
    },
    toggleAvailableFontsDropDownOpen() {
      this.availableFontsDropDownOpen = !this.availableFontsDropDownOpen
      this.$forceUpdate()
    },
    selectFont(index) {
      // _.forEach(this.availableFonts, function (availableFont){
      //   availableFont.selected = false
      // });
      this.availableFonts.map(availableFont=>{
        availableFont.selected = false
      })
      this.availableFonts[index].selected = true
      this.data[this.currSide].selectedFont = this.availableFonts[index].css
      this.$forceUpdate()
    },
    getAvailableFonts (callBack) {
      this.availableFonts = [
        {
          name: 'Arial',
          css: {'font-family': 'Arial'},
          selected: true
        },
        {
          name: 'Times New Roman',
          css: {'font-family': 'Times New Roman'},
          selected: false
        },
        {
          name: "Galada",
          css: {'font-family': 'Galada, cursive'},
          selected: false
        },
        {
          name: 'Cedarville Cursive',
          css: {'font-family': 'Cedarville Cursive'},
          selected: false
        },
        {
          name: 'Garmond',
          css: {'font-family': 'Garamond'},
          selected: false
        },
        {
          name: 'Pacifico',
          css: {'font-family': 'Pacifico, cursive'},
          selected: false
        },
        {
          name: 'Dancing Script',
          css: {'font-family': 'Dancing Script, cursive'},
          selected: false
        },
        {
          name: 'Gloria Hallelujah',
          css: {'font-family': 'Gloria Hallelujah, cursive'},
          selected: false
        }
      ]
      callBack()
    },
    imageLoaded () {
      this.data[this.currSide].isSaving = false
      this.data[this.currSide].uploaded = 0
    },
    nextStep (e) {
      if(e) {
        e.preventDefault()
      }
      console.log('next step')
      var that = this
      this.data[this.currSide].selected = true
      if(this.data[0].userInputType != 3 && this.data[1].userInputType != 3){
        that.$emit('nextStep')
      }
    },
    getGalleryImages() {
      /*ajax*/
      var that = this
      this.$http.post(
        'https://app.brighton.com/lockets/api/getGallery',
        {},
        {emulateJSON: true}
      ).then(response => {
        // success callback
        if(response.body.success) {
          that.gallery = response.body.gallery
        } else {
          
          // this['userImage'+side+'Err'] = response.body.data
        }
      }, response => {
        // error callback
        console.log(response)
      });
    },
    duplicateGalleryImage(userImage, callBack) {
      /*ajax*/
      this.$http.post(
        'https://app.brighton.com/lockets/api/duplicateGalleryImage',
        {'userImage': userImage},
        {emulateJSON: true}
      ).then(response => {
        // success callback
        if(response.body.success) {
          callBack(null, response.body.previewFileName)
        } else {
          callBack('error')
          // this['userImage'+side+'Err'] = response.body.data
        }
      }, response => {
        // error callback
        console.log(response)
        callBack('error')
      });
    },
    startOver() {
      this.$emit('startOver');
    },
    reset() {
      console.log('resetting step 1 data')
      this.data = [
        {
          userImage: null,
          userImageErr: null,
          userInputType: 1,
          userInputText1: '',
          userInputText2: '',
          userInputText3: '',
          selectedFont: '',
          isSaving: false,
          uploaded: 0
        },
         {
          userImage: null,
          userImageErr: null,
          userInputType: 1,
          userInputText1: '',
          userInputText2: '',
          userInputText3: '',
          selectedFont: '',
          isSaving: false,
          uploaded: 0
        },
         {
          userImage: null,
          userImageErr: null,
          userInputType: 1,
          userInputText1: '',
          userInputText2: '',
          userInputText3: '',
          selectedFont: '',
          isSaving: false,
          uploaded: 0
        },
         {
          userImage: null,
          userImageErr: null,
          userInputType: 1,
          userInputText1: '',
          userInputText2: '',
          userInputText3: '',
          selectedFont: '',
          isSaving: false,
          uploaded: 0
        }
      ]
    },
    removeUserImage: function () {
      // this['userImage' + side] = null;
      this.data[this.currSide].userImage = null
      // send ajax to server.....
    },
    filesChange: function (name, file, side) {
      var that = this
      var formData = new FormData();
      formData.append('side', side);
      // append Blob/File object
      formData.append('userImage', file[0], 'side'+(this.currSide)+'.jpg');
      if(file[0].size / 1000000 > 20) {
        this.data[side].userImageErr = "Please limit the file size to under 20MB"
        return false
      }
      if(file[0].type !== 'image/jpeg' && file[0].type !== 'image/png' && file[0].type !== 'image/gif' && file[0].type !== 'image/bmp') {
        this.data[this.currSide].userImageErr = "Please use image in JPEG/PNG/GIF/BMP format"
        return false
      }
      this.data[this.currSide].isSaving = true;
      this.$http.post(
        'https://app.brighton.com/lockets/api/uploadUserImages',
        formData,
        {
          emulateJSON: true,
          method: 'post',
          progress(e) {
            if (e.lengthComputable) {
              // console.log("e.loaded: %o, e.total: %o, percent: %o", e.loaded, e.total, (e.loaded / e.total ) * 100);
              that.data[that.currSide].uploaded = Math.round(e.loaded / e.total  * 100)
              that.$forceUpdate()
            }
          }
        }
      ).then(response => {
        // success callback
        if(response.body.success) {
          // this['userImage'+side] = response.body.data
          this.data[this.currSide].userImage = response.body.data
        } else {
          this.data[this.currSide].userImageErr = response.body.data
          // this['userImage'+side+'Err'] = response.body.data
        }
      }, response => {
        // error callback
        console.log(response)
      });
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.container {
  transition: all 0.3s;  
}
.container button{
  transition: all 0.3s;
  display:block;
  width:100%;
  margin-bottom:10px;
  border-radius: 4px;
  opacity:0.9;
}
.container button:hover{
  opacity:1;
}
/*.container .title{
  padding-bottom:0;
}*/
/*.container .directionText{
    color: #cd8b62;
    line-height: 1.3;
    display: block;
    padding: 11px 0;
}*/
.container .sides{
  display:block;
  
}
.container .sides div{
  display:inline-block;
  vertical-align: middle;
  padding:5px;
  margin-right:15px;
  box-sizing: border-box;
  text-align: center;
  /*width:50%;*/
  color:#000;
  /*cursor: pointer;*/
  border:1px dashed #ccc;
}
.container .sides div img{
  display:block;
  max-width:100%;
  width:50px;
  margin:0 auto
}
/*.container .sides div:hover,*/
.container .sides div.active{
  position:relative;
  /*border:1px dashed #fdc043;*/
  border:1px dashed #000;
}
.container .sides div.active:after{
  content: '';
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 5px 6px 5px;
  border-color: transparent transparent #000 transparent;
  position: absolute;
  margin-left: 50%;
  left: -4px;
  bottom: -8px;
  }


.container .userInputType{
  display:flex;
  margin-top:23px;
}
.container .userInputType div{
  display:inline-block;
  vertical-align: middle;
  width:33.333%;
  cursor: pointer;
  font-size:18px;
  text-transform: uppercase;
  color:#000;
  font-size:14px;
  padding:4px 0;
  box-sizing:border-box;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border:1px solid #000;
  background-color: #e3e3e3; 
}
.container .userInputType div.image{
  border: 1px solid #919191;
}
.container .userInputType div.text{
  border: 1px solid #919191;
  
}
.container .userInputType div.gallery{
  border: 1px solid #919191;
}
.container .userInputType div.active{
  font-weight: bold;
  background-color:#000;
  color:#fff;
  opacity:1;
}
.container form.image{
      /*border:3px solid #eed7a1;*/
      border:3px solid #000;
      padding:10px;
      box-sizing: border-box;
}
.container div.userInputText.text{
      /*border:3px solid #f7efd2*/
      border:3px solid #000;
}
.container div.gallery{
    /*border:3px solid #cd8b62*/
    border:3px solid #000;
}
.container .userInputText{
  text-align:left;
  box-sizing: border-box;
  min-height:320px;
  padding: 0 10px;
}
.container .userInputText div{
  display:block;
  padding:0;
}
.container .userInputText label{
  display:inline-block;
  margin-right:5px;
  vertical-align: middle;
  min-width:38px;
}
.container .userInputText span{
  display:inline-block;
  margin-left:5px;
  vertical-align: middle;
}
.container .userInputText input{
    max-width: 100%;
    padding: 5px;
    margin:3px auto;
    width: 50%;
    display:block;
    border:1px solid #ccc;
    box-sizing: border-box;
      display:inline-block;
  vertical-align: middle;
}
.container .userInputText .selectFont{
  display:inline-block;
  width:100%;
  position:relative;
  text-align:left;
  max-width:100%;
  box-sizing: border-box;
}
.container .userInputText .selectFont label{
  display:inline-block;
  vertical-align: middle;
  min-width:38px;
}
.container .userInputText .selectFont .fonts{
    overflow-y:scroll;
    display:inline-block;
    vertical-align: middle;
    width: 100%;
    padding:0;
    position: absolute;
    left: 0;
    top: 27px;
    border: 1px solid #ccc;
    background-color: #fff;
    height: 0;
    -webkit-transition: height 0.3s, opacity 0.2s;
    transition: height 0.3s, opacity 0.2s;
    position: absolute;
    box-sizing: border-box;
    opacity:0;

}
.container .userInputText .selectFont .fonts .font{
  /*background-color:#ebebeb;*/
  /*border-bottom:1px solid #ebebeb;*/
}
.container .userInputText .selectFont .arrow{
  display:inline-block;
  vertical-align: top;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 8px 6px 0 6px;
  border-color: #000000 transparent transparent transparent;
  margin-top: 3px;
  top: 10px;
  position: absolute;
  right: 5px;
  padding:3px 0;
}
.container .userInputText .selectFont .selectedFont{
  border:1px solid #ccc;
  position:relative;
  margin-bottom:3px;
  padding:0;
  line-height: 1.7;
  background-color:#fff;
  cursor: pointer;
  width:80%;
  display:inline-block;
  padding:5px;
  box-sizing: border-box;

}

.container .userInputText .selectFont .fonts.expand{
  height:110px;
  opacity:1;
}
.container .userInputText .selectFont .fonts .font{
  display: block;
  margin: 0;
  padding: 3px;
  box-sizing: border-box;
}
.container .userInputText .selectFont .fonts .font:hover{
  background-color:#5788a2;
  color:#fff;
  cursor: pointer;
}
.container .userInputText .selectFont .arrow.close{
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 5px 0 5px 10px;
  border-color: transparent transparent transparent #007bff;
}




.container .gallery{
  display:block;
  /*height:310px;*/
}
.container .gallery .images{
  height:310px;
  overflow-y:scroll;
}
.container .gallery .image{
  display:inline-block;
  vertical-align: middle;
  width:23%;
  box-sizing: border-box;
  padding:4px;
  margin:3px;
  border:2px solid #fabf37;
  position:relative;
  cursor: pointer;
}
.container .gallery .image:hover{
  border-color:#000;
}
.container .gallery .image img{
  display:block;
  width:auto;
  max-width:100%;
}
.container .gallery .image.selected{
  border:2px solid red;
}




.container .nextStepBtn button,
.container .control .nextStepBtn button{
  /*border:1px solid red;*/
  /*font-size:20px;*/
  /*width:100%;*/
  width:100%;
  background-color:#cd8b62;
}
.container .nextStepBtn button{
  display:inline-block;
  margin:10px auto;
  width:auto;
}







h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.side{
  cursor: pointer;
  /*width:48%;*/
  width:83%;
  margin:3px;
  display:inline-block;
  vertical-align: top;
  box-sizing:border-box;
  margin:0;
}
.side.single{
  width:100%;
}


.side .uploadedImage{
  display:inline-block;
  position: relative;
  text-align: right;  
  max-width:100%;
}
.side .uploadedImage img{
  display:block;
  max-width:100%;
}
.side .uploadedImage i.fa{
  margin-right:3px;
}



.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: #f1ece4;
  background:#f5f5f5;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  /*border-radius: 5%;*/
  background:white;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  left:0;
  position: absolute;
  cursor: pointer;
  z-index: 1;
}

.dropbox:hover {
  background: #dcd0bc; /* when mouse over to the drop zone, change color */
}
.dropbox p i.fa{
    font-size: 113px;
    position: absolute;
    opacity: 0.1;
    margin-left: 50%;
    left: -45px;
    margin-top: 50px;
    top: 0;
  animation-name: pulse;
  animation-duration: 1.1s;
  animation-iteration-count: infinite;
  animation-play-state: running; 
}
.dropbox p {
  font-size: 1.2em;
  text-align: center;
  /*padding: 50px 0;*/
  z-index: 2;
  padding: 71px 0 0 0;
/*  -webkit-transition: color 2s ease-out;
  -moz-transition: color 2s ease-out;
  -o-transition: color 2s ease-out;
  transition: color 2s ease-out;*/
  /*animation: pulse 1.5s infinite;*/
}


@keyframes pulse {
  0% {
    color: #001F3F;
    /*font-size:1.2em;*/
        /*color: #FF4136;*/
        /*color: #ccc;*/
        opacity:0.1;
  }
  20% {
    /*font-size:20px;*/
    /*color: #FF4136;*/
    color: #5788a2;
    opacity:0.3;
  }
  100% {
    opacity:0.1;
    /*font-size:1.2em;*/
    /*color: #001F3F;*/
        /*color: #ccc;*/
  }
}


@media(max-width: 971px) {
  .container .userInputText .selectFont .selectedFont,
  .container .userInputText .selectFont label{
    display:block;
    width:100%;
    text-align:center;
    line-height:1.8;
  }
  .container .userInputText div.customText{
    display:block;
    text-align:center;
  }
  .container .userInputText div.customText div{
    margin:10px 0;
  }
  .container .userInputText div.customText input{
    line-height:1.8;
    width:100%;
    text-align:center;
  }
  .container .userInputText div.customText label,
  .container .userInputText div.customText span{
    display:block;
    text-align:center;
  }
 
}
@media(max-width: 550px) {
  .container .gallery .image{
    width:44%;
  }
}




</style>
